// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "organization_service".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { depositBasisValues, footageActionValues, serviceCategoryValues, servicePaymentPolicyValues, servicePriceTypeValues, serviceSpecSourceValues } from '@borradh-workspace/labels';
/** Response atom for the "organization_service" table (1:1 with a DB row, on the wire). */
export const organizationServiceAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    category: z.enum(serviceCategoryValues),
    categoryId: z.string().nullable(),
    sortOrder: z.number(),
    isCustom: z.boolean(),
    isActive: z.boolean(),
    bookableOnline: z.boolean(),
    virtualMeeting: z.boolean(),
    requiresDeposit: z.boolean(),
    paymentPolicy: z.enum(servicePaymentPolicyValues).nullable(),
    depositBasis: z.enum(depositBasisValues).nullable(),
    depositAmountCents: z.number().nullable(),
    depositPercent: z.number().nullable(),
    painPoints: z.unknown().nullable(),
    expectedResults: z.unknown().nullable(),
    processDescription: z.string().nullable(),
    targetArea: z.string().nullable(),
    priceText: z.string().nullable(),
    priceType: z.enum(servicePriceTypeValues),
    priceCents: z.number().nullable(),
    appointmentDuration: z.number().nullable(),
    turnaroundMinutes: z.number().nullable(),
    regions: z.array(z.string()),
    footageTreatments: z.unknown(),
    footageSuggestions: z.unknown(),
    excludedStockClipIds: z.array(z.string()),
    footageOtherFields: z.array(z.string()),
    footageActions: z.array(z.enum(footageActionValues)),
    specSource: z.enum(serviceSpecSourceValues),
    expectedShotEmbedding: z.array(z.number()).nullable(),
    techniqueSlug: z.string().nullable(),
    techniqueClassifiedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=organizationService.js.map